"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketTaggingInput_1 = require("./PutBucketTaggingInput");
var PutBucketTaggingOutput_1 = require("./PutBucketTaggingOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketTagging = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketTagging",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?tagging"
    },
    input: {
        shape: PutBucketTaggingInput_1.PutBucketTaggingInput
    },
    output: {
        shape: PutBucketTaggingOutput_1.PutBucketTaggingOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketTagging.js.map